@if (state()?.value?.onFacetValue?.count || state()?.value?.isRefined) {
  <label>
    <input type="checkbox" (change)="handleChange($event)" [checked]="state()?.value?.isRefined">
    <span>{{ label() }} ({{ state()?.value?.onFacetValue?.count || 0 }})</span>
  </label>
}
